/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { MutationUpsertReservePaymentArgs } from '../gql/graphql';
import { GET_RESERVES } from './reserves.query';
import { GET_CLAIM } from './claim.query';

export function useUpsertReservePaymentMutation(
  options: MutationHookOptions<any, MutationUpsertReservePaymentArgs> = {}
) {
  const [upsertReservePayment, { loading, error, reset, data }] = useMutation(
    graphql(`
      mutation upsertReservePayment(
        $reserveUuid: String!
        $reservePaymentInput: ReservePaymentInput!
      ) {
        upsertReservePayment(
          reserveUuid: $reserveUuid
          details: $reservePaymentInput
        ) {
          uuid
          tenant
        }
      }
    `),
    {
      refetchQueries: [GET_RESERVES, GET_CLAIM],
      awaitRefetchQueries: true,
    }
  );

  return {
    upsertReservePayment,
    loading,
    error,
    reset,
    data,
  };
}
